import { Button } from "react-bootstrap";
import { GENERIC_DATA_CREATE_DEFAULT_TABLE, getApiPath } from "../../api/ApiConst";
import ApiCaller from "../../api/ApiCaller";
import { toast } from "react-toastify";


const ClientConfig = ({requestObj}) => {
    
    const addDefaultTable = (clientId) => {
        const addDefaultTablePath = getApiPath(GENERIC_DATA_CREATE_DEFAULT_TABLE);
        ApiCaller.callPostApi(addDefaultTablePath, {}, {}, (response) => {
            if(response===true){
                toast.success("Default table created successfully");
            }else{
                toast.error(response?.message ||"Default table creation failed!");
            }
        },null,clientId);
    }
    return (
        <div>
            <Button onClick={()=>addDefaultTable(requestObj?.id)}>Create Default Table</Button>
        </div>
    );
};

export default ClientConfig;